import { useMemo } from 'react';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { ReleaseSongFieldType } from 'services/store/distribution/types';

const useValidationSchema = () => {
  const { t } = useTranslation();

  const field = useMemo(
    () =>
      t(
        `distribution:tracklist:fields:${ReleaseSongFieldType.ComposerName}:name`
      ),
    [t]
  );

  const composerName = yup
    .string()
    .trim()
    .required(t('messages:validation:required', { field }))
    .max(100, t('messages:validation:maxLength', { field, length: '100' }))
    .min(5, t('messages:validation:minLength', { field, length: '5' }))
    .matches(
      /^[\p{L}][\p{L}.'\- ]*$/u,
      t('messages:validation:fieldInvalid', { field })
    );

  return composerName;
};

export default useValidationSchema;
